import * as React from 'react';
import { Column } from "react-table";
import axios from "axios";
import type { IListResponseResult, IResponse } from "../../types/api";
import Table from "../../components/table/Table";
import { API_ROUTE, CLIENT_ROUTE, CLIENT_TITLE } from "./constants";
import TableIndicator from "../../components/common/TableStatus";
import { IListParams } from "../../types/common";
import dayjs from "dayjs";
import Page from "../../components/layout/Page";
import { ICustomer, SocialAccount, SocialPlatform } from "./types";
import RowActions from "../../components/table/RowActions";
import { useListPage } from "../../hooks";
import { IconBrandApple, IconBrandFacebook, IconBrandGoogle, IconEye } from "@tabler/icons-react";
import { Link, useNavigate } from "react-router-dom";
import { Flex, ThemeIcon, Tooltip } from "@mantine/core";
import NoPaginationTable from "../../components/table/NoPaginationTable";

interface ICustomerRecord extends Pick<ICustomer, 'customerId' | 'email' | 'isActive' | 'isDeleted' | '_id' | 'createdAt' | 'phoneNumber' | 'socialAccounts'> {
    actions: unknown;
}

const CustomerList = () => {

    const navigate = useNavigate();
    const [ records, setRecords ] = React.useState<ICustomerRecord[]>([]);

    React.useEffect(() => {
        const fetchData = async () => {
            const { data } = await axios.post<IResponse<ICustomerRecord[]>>(`${API_ROUTE}/list`);
            setRecords(data.result ?? []);
        }
        void fetchData();
    }, []);

    const deleteRecord = () => {

    }

    const renderSocialIcons = (value: SocialAccount[]) => {
        const icons = [];
        for (const icon of value) {
            switch (icon.platform) {
                case SocialPlatform.APPLE: {
                    icons.push(
                        <Tooltip label={icon.reference} key={icon._id}>
                            <ThemeIcon color='gray.7' key={icon._id}>
                                <IconBrandApple/>
                            </ThemeIcon>
                        </Tooltip>
                    )
                    break;
                }
                case SocialPlatform.GOOGLE: {
                    icons.push(
                        <Tooltip label={icon.reference} key={icon._id}>
                            <ThemeIcon color='green'>
                                <IconBrandGoogle size={16}/>
                            </ThemeIcon>
                        </Tooltip>
                    )
                    break;
                }
                case SocialPlatform.FACEBOOK: {
                    icons.push(
                        <Tooltip label={icon.reference} key={icon._id}>
                            <ThemeIcon color='blue'>
                                <IconBrandFacebook size={20}/>
                            </ThemeIcon>
                        </Tooltip>
                    )
                    break;
                }
                default:
                    break;
            }
        }
        return icons;
    }

    const getTitle = (): string => {
        let title = CLIENT_TITLE;
        if (records.length > 0) {
            title = `${title}: ${records.length}`
        }
        return title;
    }

    const columns: Column<any>[] = [
            {
                Header: 'Хэрэглэгчийн ID',
                accessor: 'customerId',
                Cell: ({ value, row }) => {
                    return (
                        <Link to={'/customers/detail'} state={row.original._id}>
                            {value}
                        </Link>
                    )
                }
            },
            {
                Header: 'И-мэйл',
                accessor: 'email',
            },
            {
                Header: 'Утас',
                accessor: 'phoneNumber',
            },
            {
                Header: 'Social',
                accessor: 'socialAccounts',
                Cell: ({ value }) => {
                    return (
                        <Flex gap={3}>
                            {renderSocialIcons(value ?? [])}
                        </Flex>
                    )
                }
            },
            {
                Header: 'Төлөв',
                accessor: 'isActive',
                Cell: ({ value }) => {
                    return <TableIndicator active={value}/>;
                },
                width: 1
            },
            {
                Header: 'Үүссэн огноо',
                accessor: 'createdAt',
                Cell: ({ value }) => {
                    return (
                        <div>
                            {dayjs(value).format('YYYY.MM.DD HH:mm')}
                        </div>
                    );
                }
            },
            {
                Header: '',
                accessor: 'actions',
                Cell: (table) => {
                    return (
                        <RowActions
                            id={table.row.original._id}
                            deleteRecord={deleteRecord}
                            clientRoute={CLIENT_ROUTE}
                            customActions={[
                                {
                                    icon: <IconEye size={18}/>,
                                    onClick() {
                                        navigate('/customers/detail', { state: table.row.original._id })
                                    }
                                }
                            ]}
                        />
                    )
                }
            },
    ]

    return (
        <Page>
            <Page.Header title={getTitle()}/>
            <Page.Body>
                <NoPaginationTable
                    data={records}
                    columns={columns}
                />
            </Page.Body>
        </Page>
    )
};

export default CustomerList;